<template>
  <div>
    <v-item-group v-model="selected" :key="itemKey">
      <v-row>
        <v-col v-for="(item, i) in posters" :key="i" cols="4" md="4">
          <v-item v-slot="{ active }" class="d-flex justify-center">
            <v-img
              :src="`${APP_BASE_URL}/${item.src}?_=${Date.now()}`"
              class="text-right pa-2"
              @click="changePoster(i, active)"
              :aspect-ratio="16 / 9"
            >
              <v-btn icon dark>
                <v-icon>
                  {{
                    active
                      ? "mdi-checkbox-marked-outline"
                      : "mdi-checkbox-blank-outline"
                  }}
                </v-icon>
              </v-btn>
            </v-img>
          </v-item>
        </v-col>
        <v-col cols="4" md="4">
          <v-responsive :aspect-ratio="16 / 9">
            <v-btn
              outlined
              block
              class="poster_btn"
              @click="posterUploadHandler"
              ><v-icon>mdi-plus</v-icon></v-btn
            ></v-responsive
          >
        </v-col>
      </v-row>
    </v-item-group>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import { createFile, updateContent } from "../graphql/Mutation";
const APP_BASE_URL = process.env.VUE_APP_BASE_URL;
export default {
  name: "Posters",
  props: ["id", "poster", "poster_upload"],
  data() {
    return {
      posters: "",
      selected: "",
      APP_BASE_URL: APP_BASE_URL,
      component_poster: "",
      component_poster_upload: "",
      poster_upload_index: "",
      itemKey: 1
    };
  },
  async mounted() {
    console.log("Poster Component load", APP_BASE_URL);
    console.log(this.id, this.poster, this.poster_upload);
    this.component_poster = this.poster;
    this.component_poster_upload = this.poster_upload;
    await this.makePosterList();
    // this.checkPoster();
  },
  computed: {},
  beforeDestroy() {},
  methods: {
    async makePosterList() {
      console.log("[Poster] 포스터 리스트 만들기");
      this.posters = [];

      // 포스트 리스트 설정
      const expectedPosters = [
        {
          src: `priv/channel/${this.$store.state.channelId}/content/${this.id}/video/posters/${this.id}.0000000.jpg`
        },
        {
          src: `priv/channel/${this.$store.state.channelId}/content/${this.id}/video/posters/${this.id}.0000001.jpg`
        },
        {
          src: `priv/channel/${this.$store.state.channelId}/content/${this.id}/video/posters/${this.id}.0000002.jpg`
        },
        {
          src: `priv/channel/${this.$store.state.channelId}/content/${this.id}/video/posters/${this.id}.0000003.jpg`
        }
      ];

      const posters = [];

      for (const poster of expectedPosters) {
        const url = APP_BASE_URL + "/" + poster.src + "?_=" + Date.now();
        console.log({ url });
        const exist = await this.$urlExist(url);
        if (exist) {
          posters.push(poster);
        }
      }

      this.poster_upload_index = posters.length;
      console.log("upload_poster index", this.poster_upload_index);

      if (this.poster_upload) {
        posters.push({
          src: this.poster_upload
        });
      }

      posters.forEach((item, index) => {
        const src = item.src;
        if (src.includes(this.poster)) {
          this.selected = index;
        }
      });
      if (this.selected < 0) {
        this.selected = 0;
      }
      this.posters = posters;

      console.log("만들어진 포스터 목록", this.posters);
    },
    async checkPoster() {
      // 포스터 체크 표시

      this.posters.forEach((item, index) => {
        const src = item.src;
        if (src.includes(this.poster)) {
          this.selected = index;
        }
      });
      if (this.selected > -1) {
        this.selected = 0;
      }
      console.log("[Poster] 포스터 체크", this.poster, this.selected);
    },
    async changePoster(idx, active) {
      console.log({ idx, active });
      if (active) return;
      this.selected = idx;
      console.log(this.selected);
      this.component_poster = Number.isInteger(idx)
        ? this.posters[idx].src
        : null;
      const obj = {
        poster: this.component_poster,
        poster_upload: this.component_poster_upload
      };
      this.$emit("changePoster", obj);
    },

    posterUploadHandler() {
      const input = document.createElement("input");
      input.setAttribute("type", "file");
      input.setAttribute("accept", "image/*");
      input.click();

      input.onchange = async () => {
        let returnedUrl = "";
        const file = input.files[0];

        if (!file) return;
        this.uploading = true;

        try {
          const { data } = await this.$apollo.mutate({
            mutation: createFile,
            variables: {
              name: file.name,
              fileType: file.type,
              channel_id: this.$store.state.channelId,
              content_id: this.id,
              mode: "poster"
            },
            fetchPolicy: "no-cache"
          });

          if (data) {
            returnedUrl = data.createFile.url;
            console.log({ data, returnedUrl });
            try {
              // console.log("presigned Url", returnedUrl);
              await this.$axiosS3Public.put(returnedUrl, file, {
                headers: { "Content-Type": file.type }
              });
              this.uploading = false;
              this.uploadSuccess = true;
            } catch (e) {
              this.uploadSuccess = false;
            }
          }
        } catch (e) {
          console.log("Upload Eror", e);
        }

        if (this.uploadSuccess) {
          const temp = returnedUrl.slice(
            returnedUrl.indexOf("priv/channel"),
            returnedUrl.indexOf("?")
          );

          console.log({ temp });
          console.log(this.posters);
          console.log(this.poster_upload_index);

          this.posters[this.poster_upload_index] = { src: temp };
          if (this.selected == this.poster_upload_index) {
            this.itemKey += 1;
          }
          this.selected = this.poster_upload_index;

          this.component_poster = temp;
          this.component_poster_upload = temp;
          const obj = {
            poster: this.component_poster,
            poster_upload: this.component_poster_upload
          };
          this.$emit("changePoster", obj);
        }
      };
    }
  }
};
</script>

<style></style>
